<template>
  <div class="vertical-center">
    <div v-if="this.params.value !== null">
      <vs-button class="float-left mr-2 padding-x-05" type="filled" color="success" size="small">Has Config</vs-button>
    </div>
    <div v-else>
      <vs-button class="float-left mr-2 padding-x-05" type="filled" color="danger"  size="small">No Config</vs-button>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";

  export default Vue.extend({
    name: 'DeviceRequestStatus',
    data() {
      return {
        value: ''
      }
    },
    mounted() {
    }
  })
</script>

<style scoped>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .padding-x-05 {
    padding-left: 0.5em!important;
    padding-right: 0.5em!important;
  }
</style>

